import { render, staticRenderFns } from "./Wrestler.vue?vue&type=template&id=6526fbdc&scoped=true"
import script from "./Wrestler.vue?vue&type=script&lang=js"
export * from "./Wrestler.vue?vue&type=script&lang=js"
import style0 from "./Wrestler.vue?vue&type=style&index=0&id=6526fbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526fbdc",
  null
  
)

export default component.exports